import styled, { css, keyframes } from 'styled-components';

const speechBubbleVisibilityDuration = '4s';
const pointerSize = '16px';

export enum SpeechBubbleOrientation {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

export enum SpeechBubbleLocation {
  Before = 'before',
  After = 'after',
}

const FadeoutKeyframes = keyframes`
  0% { opacity: 0; }
  1% { opacity: 1; }
  75% { opacity: 1; }
  100% { opacity: 0; }
`;

// from https://projects.verou.me/bubbly/
export const SpeechBubble = styled.hgroup<{
  $orientation: SpeechBubbleOrientation;
  $location?: SpeechBubbleLocation;
  $horizontalOffset?: string;
  $verticalOffset?: string;
  $suppressFadeOut?: boolean;
}>`
  position: absolute;
  background: var(--color-tooltip-background);
  color: var(--color-background);
  border-radius: 0.4em;
  z-index: 10;
  ${(props) =>
    props.$orientation === SpeechBubbleOrientation.Horizontal
      ? `
        margin-left: ${pointerSize};
        left: 100%;
        top: calc(-60% ${props.$verticalOffset ? `+ ${props.$verticalOffset}` : ''});
      `
      : props.$location === SpeechBubbleLocation.Before
        ? `
        margin-bottom: ${pointerSize};
        bottom: 100%;
        left: 0;
        right: 0;
      `
        : `
        margin-top: ${pointerSize};
        left: 0;
        right: 0;
      `}
  ${(props) => (props.$horizontalOffset ? `margin-left: ${props.$horizontalOffset};` : '')}
  width: fit-content;
  pointer-events: none;
  ${({ $suppressFadeOut }) => ($suppressFadeOut ? '' : 'opacity: 0;')}
  ${({ $suppressFadeOut }) =>
    $suppressFadeOut
      ? ''
      : css`
          animation: ${FadeoutKeyframes} ${speechBubbleVisibilityDuration};
        `};
  *::after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    ${(props) =>
      props.$orientation === SpeechBubbleOrientation.Horizontal
        ? `
          left: 0;
          top: 45%;
          border: ${pointerSize} solid transparent;
          border-right-color: var(--color-tooltip-background);
          margin-top: - calc(${pointerSize} / 2);
          margin-left: -${pointerSize};
          border-top: 0;
          border-left: 0;
        `
        : props.$location === SpeechBubbleLocation.Before
          ? `
          bottom: 0;
          left: 50%;
          border: ${pointerSize} solid transparent;
          border-top-color: var(--color-tooltip-background);
          margin-left: - calc(${pointerSize} / 2);
          margin-bottom: -${pointerSize};
          border-bottom: 0;
          border-right: 0;
        `
          : `
          top: 0;
          left: 50%;
          border: ${pointerSize} solid transparent;
          border-bottom-color: var(--color-tooltip-background);
          margin-left: - calc(${pointerSize} / 2);
          margin-top: -${pointerSize};
          border-top: 0;
          border-left: 0;
        `}
    ${({ $suppressFadeOut }) => ($suppressFadeOut ? '' : 'opacity: 0;')}
    ${({ $suppressFadeOut }) =>
      $suppressFadeOut
        ? ''
        : css`
            animation: ${FadeoutKeyframes} ${speechBubbleVisibilityDuration};
          `};
  }
`;
